import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { authGuardSubmodule } from '../../auth/auth.guard';
import { PerspectivaComponent } from './perspectiva/perspectiva.component';
import { IndicadoresMetasComponent } from './indicadores-metas/indicadores-metas.component';
import { ProyectosEstrategicosComponent } from './proyectos-estrategicos/proyectos-estrategicos.component';
import { FilosofiacorporativaComponent } from './filosofiacorporativa/filosofiacorporativa.component';
import { MatrizFodaComponent } from './matriz-foda/matriz-foda.component';
import { MatrizRiesgosOportunidadesComponent } from './matriz-riesgos-oportunidades/matriz-riesgos-oportunidades.component';
import { CuadroMandoIntegralComponent } from './cuadro-mando-integral/cuadro-mando-integral.component';
import { AltaPlanesComponent } from './alta-planes/alta-planes.component';
import { AltaActasComponent } from './alta-actas/alta-actas.component';
import { ObjetivosComponent } from './objetivos/objetivos.component';
import { AlineamientoEstrategicoComponent } from './alineamiento-estrategico/alineamiento-estrategico.component';
import { AltaproyectosComponent } from './altaproyectos/altaproyectos.component';


const routes: Routes = [
  {
    path: 'app/formulacion',
    component: ContenedorComponent,
    children: [
      {path: 'perspectivas', component: PerspectivaComponent, canActivate: [authGuardSubmodule]},
      {path: 'indicadores-metas', component: IndicadoresMetasComponent, canActivate: [authGuardSubmodule]},
      {path: 'filosofiacorporativa', component: FilosofiacorporativaComponent, canActivate: [authGuardSubmodule]},
      {path: 'matriz-foda', component: MatrizFodaComponent, canActivate: [authGuardSubmodule]},
      {path: 'matriz-riesgos-oportunidades', component: MatrizRiesgosOportunidadesComponent, canActivate: [authGuardSubmodule]},
      {path: 'objetivos', component: ObjetivosComponent, canActivate: [authGuardSubmodule]},
      {path: 'alineamiento-estrategico', component: AlineamientoEstrategicoComponent, canActivate: [authGuardSubmodule]},
      {path: 'alta-proyectos', component: AltaproyectosComponent, canActivate: [authGuardSubmodule]},
      {path: 'proyectos-estrategicos', component: ProyectosEstrategicosComponent, canActivate: [authGuardSubmodule]},
      {path: 'cuadro-mando-integral', component: CuadroMandoIntegralComponent, canActivate: [authGuardSubmodule]},
      {path: 'alta-planes', component: AltaPlanesComponent, canActivate: [authGuardSubmodule]},
      {path: 'alta-actas', component: AltaActasComponent, canActivate: [authGuardSubmodule]},
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FormulacionRoutingModule { }
